module.exports = __webpack_public_path__ + "img/gears.73847908.gif";